import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./assets/scss/dashlite.scss";
import Results from "./pages/results";
import RedirectUrl from "./components/redirect/RedirectUrl";
import Error404Modern from "./pages/error/404-modern";
import EmbeddedTypeform from "./pages/index";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <Routes>
      <Route
        path="/"
        element={<RedirectUrl url="https://www.texpertai.co.uk" />}
      />
      <Route path=":formId" element={<EmbeddedTypeform />} />
      <Route path="results/:formId/:resultId" element={<Results />} />
      <Route path="not-found" element={<RedirectUrl url="https://www.texpertai.co.uk/404" />} />
    </Routes>
  </BrowserRouter>
);
